export default {
  name: 'contactUpdateDetails',
  props: ['rowData', 'contactUpdateDetails', 'eventId'],
  data() {
    return {
      loader: false,
      isSuccess: false,
      responseMsg: null,
      showAlert: false,
      vendorName: null,
      vendorCode: null,
      contactNumber: null,
      email: null,
      creationDate: null,
      appStatus: null,
      department: null,
      uuid: null,
      allFlag: false,
      approvalHistoryData: [],
      approvalHistoryFields: [
        {
          key: 'approver_name'
        },
        { key: 'approver_designation', label: 'Designation' },
        {
          key: 'action_date'
        },
        {
          key: 'seq_order',
          label: 'Approver Order'
        },
        {
          key: 'approval_status',
          label: 'Status'
        },
        {
          key: 'comments'
        }
      ],
      wfMenuId: null,
      approvalStatus: null,
      recordId: null,
      showApproveModal: false,
      showRejectModal: false,
      approvalReason: null,
      rejectedReason: null,
      wfDtlId: null
    };
  },
  mounted() {
    if (this.rowData) {
      this.approvalStatus = this.rowData.approval_status;
      this.recordId = this.rowData.party_contact_req_update_id;
      this.getVendorContactUpdateDataById();
    } else if (this.contactUpdateDetails) {
      this.approvalStatus = this.contactUpdateDetails.approval_status;
      this.recordId = this.contactUpdateDetails.party_contact_req_update_id;
      this.wfDtlId = this.contactUpdateDetails.wf_inprocess_dtl_id;
      this.getVendorContactUpdateDataById();
    }
    if (
      this.approvalStatus == 'APPROVED' ||
      this.approvalStatus == 'INPROCESS'
    ) {
      this.getMenuId();
    }

    if (this.eventId) {
      this.getHistory(this.eventId);
    }
  },
  methods: {
    getVendorContactUpdateDataById() {
      const payload = {
        partyReqid: this.recordId
      };
      this.loader = true;
      this.$store
        .dispatch('vendorUpdate/getVendorContactUpdateDataById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.vendorName = result.name;
            (this.vendorCode = result.vendor_code),
              (this.contactNumber = result.mob),
              (this.email = result.email),
              (this.creationDate = result.creation_date),
              (this.appStatus = result.approval_status),
              (this.department = result.department),
              (this.uuid = result.uuid);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getMenuId() {
      const payload = {
        event_name: this.$route.name
      };
      this.$store
        .dispatch('intWorkflow/getDynamicMenuId', payload)
        .then(response => {
          if (response.status === 200) {
            const result = response.data.data;
            if (result) {
              this.wfMenuId = result.menu_id;
              this.getEventId();
            }
          }
        });
    },
    getEventId() {
      this.$store
        .dispatch('intWorkflow/getEventId', this.wfMenuId)
        .then(response => {
          if (response.status === 200) {
            this.eventID = response.data.data;
            this.getHistory();
          }
        });
    },

    switchVariable() {
      this.allFlag = this.allFlag
        ? (this.allFlag = false)
        : this.allFlag == false
        ? (this.allFlag = true)
        : null;
      this.getHistory(this.eventId);
    },
    getHistory(id) {
      const payload = {
        eventId: this.eventID ? this.eventID : id,
        nfaHdrId: this.recordId,
        approvalStatus: this.allFlag ? 'Y' : !this.allFlag ? 'N' : ''
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getApprovalList', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.approvalHistoryData = response.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideApproveModal(flag) {
      this.showApproveModal = flag;
      if (!flag) {
        this.approvalReason = null;
      }
    },
    showHideRejectModal(flag) {
      this.showRejectModal = flag;
      if (!flag) {
        this.rejectedReason = null;
      }
    },
    approveRejectInvoiceApproval(status) {
      const payload = {
        event_id: this.eventId,
        wf_inprocess_dtl_id: this.wfDtlId,
        notification_status: status,
        notification_comments:
          status === 'REJECTED' ? this.rejectedReason : this.approvalReason
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/approvalRejectSingle', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.getVendorContactUpdateDataById();
            this.getMenuId();
            // this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            if (status === 'REJECTED') {
              this.showHideRejectModal(false);
            } else if (status === 'APPROVED') {
              this.showHideApproveModal(false);
            }
          } else {
            this.showAlert = false;
            alert(response.response.data.message);
            // this.isSuccess = false;
            // this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  }
};
